const grouping = {
  NAME: 'name',
  CATEGORY: 'category',
}

export {
  grouping,
}
